import { useMemo } from "react";

import { ICategoryCount } from "web/types/CategoryCount";

const useCategoryIdsAmount = (
  categoriesCountData?: { node: ICategoryCount }[]
) =>
  useMemo(() => {
    if (categoriesCountData?.length) {
      return categoriesCountData.map(({ node: item }) => ({
        id: item.id,
        product_count: item.product_count,
      }));
    }
    return [];
  }, [categoriesCountData]);

export default useCategoryIdsAmount;
